(function () {
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function parseDiscountPct(block) {
    var pct = parseInt(block.getAttribute('data-discount-percentage'), 10);
    if (isNaN(pct) || pct < 1 || pct >= 100) return 0;
    return pct;
  }

  function getDisplayPricing(variant, discountPct) {
    if (variant.sale_price != null && variant.sale_price !== '') {
      var sale = Number(variant.sale_price) || 0;
      var regular = Number(variant.regular_price) || 0;
      return {
        sale: sale,
        regular: regular,
        savings: Math.max(0, regular - sale),
        showCompare: regular > sale
      };
    }

    var price = Number(variant.price) || 0;
    var compareAt = Number(variant.compare_at_price) || 0;
    var regularPrice = compareAt > price ? compareAt : price;
    var salePrice = price;

    if (discountPct > 0) {
      salePrice = Math.round((price * (100 - discountPct)) / 100);
    }

    return {
      sale: salePrice,
      regular: regularPrice,
      savings: Math.max(0, regularPrice - salePrice),
      showCompare: regularPrice > salePrice
    };
  }

  function initProductBlock(block) {
    var dataEl = block.querySelector('[data-brecka-product-json]');
    var priceEl = block.querySelector('[data-brecka-price]');
    var compareEl = block.querySelector('[data-brecka-compare]');
    var badgeEl = block.querySelector('[data-brecka-badge]');
    var variantInput = block.querySelector('[data-brecka-variant-id]');
    var promoInput = block.querySelector('[data-brecka-promo-code]');
    var button = block.querySelector('[data-brecka-checkout]');
    var variantButtons = block.querySelectorAll('[data-brecka-variant-option]');

    if (!dataEl || !button) return;

    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    if (!variants.length) return;

    var moneyFormat = block.dataset.moneyFormat || '${{amount}}';
    var discountPct = parseDiscountPct(block);
    var selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantInput && variantInput.value);
    }) || variants[0];

    function updatePrices(variant) {
      selectedVariant = variant;

      if (variantInput) {
        variantInput.value = variant.id;
      }

      var pricing = getDisplayPricing(variant, discountPct);

      if (priceEl) {
        priceEl.textContent = formatMoney(pricing.sale, moneyFormat);
      }

      if (compareEl) {
        if (pricing.showCompare) {
          compareEl.textContent = formatMoney(pricing.regular, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (badgeEl) {
        if (discountPct > 0) {
          badgeEl.textContent = discountPct + '% OFF';
          badgeEl.hidden = false;
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var discountPercent = Math.round(
            ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
          );
          badgeEl.textContent = discountPercent + '% OFF';
          badgeEl.hidden = false;
        } else if (block.dataset.breckaBadgeFallback) {
          badgeEl.textContent = block.dataset.breckaBadgeFallback;
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }

      variantButtons.forEach(function (option) {
        var isSelected = String(option.dataset.variantId) === String(variant.id);
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    variantButtons.forEach(function (option) {
      option.addEventListener('click', function () {
        var variant = variants.find(function (item) {
          return String(item.id) === String(option.dataset.variantId);
        });

        if (variant) {
          updatePrices(variant);
        }
      });
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();

      if (!selectedVariant) return;

      button.disabled = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var promoCode = promoInput ? promoInput.value.trim() : '';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: selectedVariant.id,
              quantity: 1
            }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }

          if (promoCode) {
            window.location.href =
              root +
              'discount/' +
              encodeURIComponent(promoCode) +
              '?redirect=' +
              encodeURIComponent(root + 'checkout');
            return;
          }

          window.location.href = root + 'checkout';
        })
        .catch(function () {
          button.disabled = false;
        });
    });

    updatePrices(selectedVariant);
  }

  function initHeatCompare(root) {
    var wrap = root.matches('[data-brecka-heat-compare]')
      ? root
      : root.querySelector('[data-brecka-heat-compare]');
    if (!wrap) return;

    var slider = wrap.querySelector('.nw-brecka-adv__heat-slider');
    var hotLayer = wrap.querySelector('[data-brecka-heat-hot]');
    var handle = wrap.querySelector('[data-brecka-heat-handle]');
    var divider = wrap.querySelector('[data-brecka-heat-divider]');

    if (!slider || !hotLayer || !handle || !divider) return;

    var dragging = false;
    var start = parseFloat(wrap.dataset.start || '42');

    function setPosition(percent) {
      var value = Math.max(0, Math.min(100, percent));
      slider.style.setProperty('--nw-brecka-heat-split', value + '%');
      hotLayer.style.clipPath = 'inset(0 0 0 ' + value + '%)';
      handle.style.left = value + '%';
      divider.style.left = value + '%';
    }

    function updateFromClientX(clientX) {
      var rect = slider.getBoundingClientRect();
      if (!rect.width) return;
      setPosition(((clientX - rect.left) / rect.width) * 100);
    }

    setPosition(start);

    slider.addEventListener('mousedown', function (event) {
      dragging = true;
      updateFromClientX(event.clientX);
      event.preventDefault();
    });

    slider.addEventListener(
      'touchstart',
      function (event) {
        dragging = true;
        if (event.touches && event.touches[0]) {
          updateFromClientX(event.touches[0].clientX);
        }
      },
      { passive: true }
    );

    window.addEventListener('mousemove', function (event) {
      if (!dragging) return;
      updateFromClientX(event.clientX);
    });

    window.addEventListener(
      'touchmove',
      function (event) {
        if (!dragging || !event.touches || !event.touches[0]) return;
        updateFromClientX(event.touches[0].clientX);
      },
      { passive: true }
    );

    window.addEventListener('mouseup', function () {
      dragging = false;
    });

    window.addEventListener('touchend', function () {
      dragging = false;
    });
  }

  function initMoistureStack(root) {
    var stack = root.matches('[data-brecka-moisture-stack]')
      ? root
      : root.querySelector('[data-brecka-moisture-stack]');
    if (!stack || stack.dataset.breckaMoistureInit === 'true') return;

    stack.dataset.breckaMoistureInit = 'true';

    function update() {
      var rect = stack.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var start = viewportHeight * 0.9;
      var travel = rect.height + viewportHeight * 0.35;
      var progress = (start - rect.top) / travel;
      progress = Math.max(0, Math.min(1, progress));
      stack.style.setProperty('--nw-brecka-moisture-progress', String(progress));
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  function initFaq(root) {
    var faqBlocks = root.matches('[data-brecka-faq]')
      ? [root]
      : Array.prototype.slice.call(root.querySelectorAll('[data-brecka-faq]'));

    faqBlocks.forEach(function (block) {
      if (block.dataset.breckaFaqInit === 'true') return;
      block.dataset.breckaFaqInit = 'true';

      block.querySelectorAll('[data-brecka-faq-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('.nw-brecka-adv__faq-item');
          var panel = item ? item.querySelector('[data-brecka-faq-panel]') : null;
          if (!item || !panel) return;

          var isOpen = item.classList.contains('is-open');

          if (isOpen) {
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            panel.style.maxHeight = '0px';
            return;
          }

          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        });
      });
    });
  }

  function initOfferBlock(block) {
    var dataEl = block.querySelector('[data-brecka-product-json]');
    var savingsEl = block.querySelector('[data-brecka-offer-savings]');
    var offerButton = block.querySelector('[data-brecka-offer-button]');
    var buttonLabelEl = block.querySelector('[data-brecka-offer-button-label]');
    var variantInput = block.querySelector('[data-brecka-variant-id]');
    var promoInput = block.querySelector('[data-brecka-promo-code]');
    var checkoutButton = block.querySelector('[data-brecka-checkout]');
    var variantButtons = block.querySelectorAll('[data-brecka-variant-option]');
    var moneyFormat = block.dataset.moneyFormat || '${{amount}}';
    var discountPct = parseDiscountPct(block);
    var buttonPrefix = buttonLabelEl ? buttonLabelEl.textContent.trim() : 'CLAIM MY 20% OFF';

    if (!dataEl || !checkoutButton) return;

    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    if (!variants.length) return;

    var selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantInput && variantInput.value);
    }) || variants[0];

    function updateOfferUi(variant) {
      selectedVariant = variant;

      if (variantInput) {
        variantInput.value = variant.id;
      }

      var pricing = getDisplayPricing(variant, discountPct);

      if (savingsEl) {
        savingsEl.textContent = pricing.showCompare ? formatMoney(pricing.savings, moneyFormat) : '';
      }

      if (offerButton) {
        offerButton.textContent = buttonPrefix + ' · ' + variant.title + ' →';
      }

      variantButtons.forEach(function (option) {
        var optionVariant = variants.find(function (item) {
          return String(item.id) === String(option.dataset.variantId);
        });
        var compareEl = option.querySelector('[data-brecka-offer-compare]');
        var priceEl = option.querySelector('[data-brecka-offer-price]') || option.querySelector('.nw-brecka-adv__offer-size-price');
        var isSelected = String(option.dataset.variantId) === String(variant.id);

        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        if (optionVariant && priceEl) {
          var optionPricing = getDisplayPricing(optionVariant, discountPct);
          priceEl.textContent = formatMoney(optionPricing.sale, moneyFormat);

          if (compareEl) {
            if (optionPricing.showCompare) {
              compareEl.textContent = formatMoney(optionPricing.regular, moneyFormat);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
        }
      });
    }

    variantButtons.forEach(function (option) {
      option.addEventListener('click', function () {
        var variant = variants.find(function (item) {
          return String(item.id) === String(option.dataset.variantId);
        });

        if (variant) {
          updateOfferUi(variant);
        }
      });
    });

    checkoutButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (!selectedVariant) return;

      checkoutButton.disabled = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var promoCode = promoInput ? promoInput.value.trim() : '';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: selectedVariant.id,
              quantity: 1
            }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }

          if (promoCode) {
            window.location.href =
              root +
              'discount/' +
              encodeURIComponent(promoCode) +
              '?redirect=' +
              encodeURIComponent(root + 'checkout');
            return;
          }

          window.location.href = root + 'checkout';
        })
        .catch(function () {
          checkoutButton.disabled = false;
        });
    });

    updateOfferUi(selectedVariant);
  }

  function initSection(section) {
    section.querySelectorAll('[data-brecka-product]').forEach(function (block) {
      if (block.matches('[data-brecka-offer]')) {
        initOfferBlock(block);
      } else {
        initProductBlock(block);
      }
    });
    section.querySelectorAll('[data-brecka-heat-compare]').forEach(initHeatCompare);
    section.querySelectorAll('[data-brecka-moisture-stack]').forEach(initMoistureStack);
    initFaq(section);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-brecka-adv-section]').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-brecka-adv-section]') || event.target;
    if (section.matches('[data-brecka-adv-section]')) {
      initSection(section);
    }
  });
})();
